import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { getRegionLanguages } from '../../utils/useRegions';

import * as S from './style';

const Header = () => {
  const [showLangSwitcher, setShowLangSwitcher] = useState(false);
  const { i18n } = useTranslation();
  const { language } = i18n;
  const { pathname } = useLocation();
  const countryCode = pathname?.split('/')?.[1];
  const navigate = useNavigate();
  const regionLanguages = getRegionLanguages(countryCode);

  useEffect(() => {
    setShowLangSwitcher(regionLanguages?.length > 1);
  }, [countryCode]);

  const getNewPath = (newLang) => {
    return pathname.replace(language, newLang);
  };

  const onClickHandle = (e) => {
    const { innerHTML: lang } = e.target;
    i18n.changeLanguage(lang);
    navigate(getNewPath(lang), { replace: true });
  };

  const LangSwitcher = (langCodes) => {
    if (!langCodes) return null;
    return (
      <S.Right>
        {langCodes.map((l) => (
          <S.NavButton key={l} isactive={+(l === language)} onClick={onClickHandle}>
            {l}
          </S.NavButton>
        ))}
      </S.Right>
    );
  };

  return <S.Header>{showLangSwitcher ? LangSwitcher(regionLanguages) : null}</S.Header>;
};

export default Header;
